export const decodeBase64 = (data) => {
  // https://stackoverflow.com/a/45833671
  const bs = window.atob(data);
  const buffer = new ArrayBuffer(bs.length);
  const ba = new Uint8Array(buffer);
  for (let i = 0; i < bs.length; i += 1) {
    ba[i] = bs.charCodeAt(i);
  }
  return ba;
};

export const hasKey = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
